export default __webpack_public_path__ + "static/media/BarcodeIconOff.bbc683c8.svg";